<template>
  <div class="md:!px-10 !px-5 ">
    
    <MainTop />
    <AllUserCard />
  </div>

</template>
<script>
import AllUserCard from './AllUserCard.vue';
import MainTop from './MainTop.vue'
import UserCard from './UserCard.vue';
export default {
  components: { MainTop, UserCard, AllUserCard },
  data() {
    return {
      
    }
  },

}
</script>